/**
 * 사용자 로그인 상태를 확인합니다.
 * `localStorage`에 저장된 'isCustomLogin' 값과 추가 조건을 기반으로 결과를 반환합니다.
 *
 * @param {(() => boolean) | boolean} [additionalCondition] - 선택적 추가 조건.
 * 함수 또는 불리언 값으로 전달 가능하며, 해당 조건이 만족되면 로그인 상태로 간주됩니다.
 * @returns {boolean} 사용자가 로그인 상태인지 여부.
 *
 * @example
 * 'isCustomLogin' 값이 'true'이고 추가 조건이 없는 경우:
 * localStorage.setItem('isCustomLogin', 'true');
 * const isLoggedIn = checkIsLogin();
 * console.log(isLoggedIn); // true
 *
 * 'isCustomLogin' 값이 'true'이고 추가 조건이 함수인 경우:
 * const isLoggedIn = checkIsLogin(() => true);
 * console.log(isLoggedIn); // true
 *
 * 'isCustomLogin' 값이 'true'이고 추가 조건이 false인 경우:
 * const isLoggedIn = checkIsLogin(false);
 * console.log(isLoggedIn); // false
 *
 * 'isCustomLogin' 값이 'false'인 경우 (어떤 추가 조건도 무시):
 * localStorage.setItem('isCustomLogin', 'false');
 * const isLoggedIn = checkIsLogin(() => true);
 * console.log(isLoggedIn); // false
 */
export const checkIsLogin = (additionalCondition?: (() => boolean) | boolean) => {
  if (typeof additionalCondition === 'function') {
    return window.localStorage.getItem('isCustomLogin') === 'true' && additionalCondition();
  }
  if (additionalCondition === undefined) {
    return window.localStorage.getItem('isCustomLogin') === 'true';
  } else {
    return window.localStorage.getItem('isCustomLogin') === 'true' && additionalCondition;
  }
};
